module.exports = __webpack_public_path__ + "media/images/emblems/Kuesnacht-blazon-03a8e22cae23e9634c9338c156c91ba2.svg";